import React, { useEffect, useState } from "react";
import {
  Slider,
  WorkBox,
  Animatedcounter,
  Ourpartner,
  Projectcategories,
  Featuredproperties,
} from "../Components"; //PartnerBox
import { Col, Container, Row } from "react-bootstrap";
import { WorkIcon, WorkIconOne, WorkIconTwo, WorkIconThree } from "../images";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// import { AiOutlineAreaChart } from "react-icons/ai";
import apiClient from "../Config/apiConfig";
const config = {
  BASE_URL: "https://admin.thezeeshangroup.com/",
};

const Home = () => {
  const [gethomepageData, setGethomepageData] = useState([]);
  const homepageApi = async () => {
    try {
      const res = await apiClient.get(`api/homepages`);
      setGethomepageData(res.data);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    homepageApi();
  }, []);
  return (
    <>
      <Slider />
      <div className="buy-us partner-sec">
        <Container>
          <Row>
            <Col sm="12">
              <h2>Featured Properties</h2>
              <p className="homePTag">
                {gethomepageData && gethomepageData.featured_properties_desc}
              </p>
            </Col>
          </Row>
          <Row>
            <Featuredproperties />
          </Row>
        </Container>
      </div>
      <div className="loan-section">
        <Container>
          <Row>
            <Col sm="12" className="text-center">
              <h2>Zeeshan Group Of Companies </h2>
              <p className="m-0 pb-5">
                {gethomepageData && gethomepageData.group_companies_desc}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg="6" md="6" className="align-self-center">
              <div className="loan-img-sec">
                {gethomepageData?.construction_image?.length > 1 && (
                  <OwlCarousel
                    className="owl-theme"
                    loop="true"
                    autoplay
                    items={1}
                    autoplayTimeout="8000"
                    autoplaySpeed="2000"
                    dots="false"
                  >
                    <>
                      {gethomepageData?.construction_image?.map((image, i) => {
                        return (
                          <div className="item">
                            <img
                              src={`${config.BASE_URL}uploads/${image}`}
                              alt="Zeeshan Construction"
                            />
                          </div>
                        );
                      })}
                    </>
                  </OwlCarousel>
                )}
                {/* {gethomepageData?.construction_image?.length > 1 && (
                  <div className="slide-track">
                    {gethomepageData?.construction_image?.map((image, i) => {
                      return (
                        <div className="slide">
                          <img
                            src={`${config.BASE_URL}uploads/${image}`}
                            alt="Zeeshan Construction"
                          />
                        </div>
                      );
                    })}
                  </div>
                )} */}

                {gethomepageData?.construction_image?.length == 1 && (
                  <div className="slide">
                    <img
                      src={`${config.BASE_URL}uploads/${gethomepageData?.construction_image[0]}`}
                      alt="Zeeshan Construction"
                    />
                  </div>
                )}
              </div>
            </Col>
            <Col lg="6" md="6" className="align-self-center">
              <h2>Zeeshan Construction</h2>
              <p>{gethomepageData && gethomepageData.construction_desc}</p>
              <div className="header-button">
                <a href="/">View more</a>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 tabflex" id="zeeshantrader">
            <Col lg="6" md="6" className="align-self-center">
              <h2>Zaira and Zeeshan Trader</h2>
              <p>{gethomepageData && gethomepageData.zaira_trader_desc}</p>
              <div className="header-button">
                <a href="/">View more</a>
              </div>
            </Col>
            <Col lg="6" md="6" className="align-self-center">
              <div className="loan-img-sec">
                {gethomepageData?.zaira_trader_image?.length > 1 && (
                  <OwlCarousel
                    className="owl-theme"
                    loop="true"
                    autoplay
                    items={1}
                    autoplayTimeout="8000"
                    autoplaySpeed="2000"
                    dots="false"
                  >

                    <>
                      {gethomepageData?.zaira_trader_image?.map((image, i) => {
                        return (
                          <div className="item">
                            <img
                              src={`${config.BASE_URL}uploads/${image}`}
                              alt="Zeeshan Construction"
                            />
                          </div>
                        );
                      })}
                    </>
                  </OwlCarousel>
                )}
                {gethomepageData?.zaira_trader_image?.length == 1 && (
                  <div className="slide">
                    <img
                      src={`${config.BASE_URL}uploads/${gethomepageData?.zaira_trader_image[0]}`}
                      alt="Zeeshan Construction"
                    />
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col lg="6" md="6" className="align-self-center">
              <div className="loan-img-sec">
                {gethomepageData?.zaira_construction_image?.length > 1 && (
                  <OwlCarousel
                    className="owl-theme"
                    loop="true"
                    autoplay
                    items={1}
                    autoplayTimeout="8000"
                    autoplaySpeed="2000"
                    dots="false"
                  >

                    <>
                      {gethomepageData?.zaira_construction_image?.map(
                        (image, i) => {
                          return (
                            <div className="item">
                              <img
                                src={`${config.BASE_URL}uploads/${image}`}
                                alt="Zeeshan Construction"
                              />
                            </div>
                          );
                        }
                      )}
                    </>
                  </OwlCarousel>
                )}
                {gethomepageData?.zaira_construction_image?.length == 1 && (
                  <div className="slide">
                    <img
                      src={`${config.BASE_URL}uploads/${gethomepageData?.zaira_construction_image[0]}`}
                      alt="Zeeshan Construction"
                    />
                  </div>
                )}
              </div>
            </Col>
            <Col lg="6" md="6" className="align-self-center">
              <h2>Zaira and Zeeshan Construction</h2>
              <p>
                {gethomepageData && gethomepageData.zaira_construction_desc}
              </p>
              <div className="header-button">
                <a href="/">View more</a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="fun-section centred green-bg">
        {/* <span className="big-text">Fun Numbers</span> */}
        <div className="bg-layer">
          <div className="bg-1"></div>
          <div className="bg-2"></div>
        </div>
        <Animatedcounter />
      </div>
      <div className="buy-us">
        <Container>
          <Row>
            <Col sm="12">
              <h2>Why Buy From Us</h2>
              <p>{gethomepageData && gethomepageData.why_buy_from_us_dec}</p>
            </Col>
            {/* <Col sm="12">
              <OwlCarousel className="slider-items owl-carousel" {...options}>
                <div className="item">
                  <WorkBox
                    id={"bg-1"}
                    image={WorkIcon}
                    title={"Wide Range of Properties"}
                    desc={
                      "A home is where you would spend your life. Our wide range of available properties ensures that you buy only the home that best suits your requirements."
                    }
                  />
                </div>
                <div className="item">
                  <WorkBox
                    id={"bg-2"}
                    image={WorkIcon}
                    title={"Wide Range of Properties"}
                    desc={
                      "A home is where you would spend your life. Our wide range of available properties ensures that you buy only the home that best suits your requirements."
                    }
                  />
                </div>
                <div className="item">
                  <WorkBox
                    id={"bg-3"}
                    image={WorkIcon}
                    title={"Wide Range of Properties"}
                    desc={
                      "A home is where you would spend your life. Our wide range of available properties ensures that you buy only the home that best suits your requirements."
                    }
                  />
                </div>
                <div className="item">
                  <WorkBox
                    id={"bg-1"}
                    image={WorkIcon}
                    title={"Wide Range of Properties"}
                    desc={
                      "A home is where you would spend your life. Our wide range of available properties ensures that you buy only the home that best suits your requirements."
                    }
                  />
                </div>
              </OwlCarousel>
            </Col> */}
          </Row>
          <Row>
            <Col lg="3" sm="6">
              <WorkBox
                id={"bg-1"}
                image={WorkIcon}
                title={"QUALITY"}
                desc={
                  "A home is where you would spend your life. Our wide range of available properties ensures that you buy only the home that best suits your requirements."
                }
              />
            </Col>
            <Col lg="3" sm="6">
              <WorkBox
                id={"bg-2"}
                image={WorkIconOne}
                title={"SAFETY"}
                desc={
                  "Safety is not only a top priority but also a steadfast commitment at Zeeshan Group. Since we are aware that construction sites may be unpredictable and sometimes dangerous places, we go to great lengths to protect the safety of our employees, business partners, and the general public."
                }
              />
            </Col>
            <Col lg="3" sm="6">
              <WorkBox
                id={"bg-3"}
                image={WorkIconTwo}
                title={"INNOVATION"}
                desc={
                  "At Zeeshan Group, we are innovators influencing the future of construction rather than just being builders. Innovation is the driving force behind all we do, inspiring us to design environments that inspire, use few resources, and push the boundaries of technology and design."
                }
              />
            </Col>
            <Col lg="3" sm="6">
              <WorkBox
                id={"bg-1"}
                image={WorkIconThree}
                title={"COMMITMENT"}
                desc={
                  "The foundation of Zeeshan Group's success is our dedication, which goes beyond a simple pledge. We're committed to providing top-notch construction services that go beyond only physical structure."
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="buy-us project-categories" id="zeeshanconstruction">
        <Container>
          <Row>
            <Col sm="12">
              <h2>Project Categories</h2>
              <p>{gethomepageData && gethomepageData.project_categories_dec}</p>
            </Col>
            <Projectcategories />
          </Row>
        </Container>
      </div>
      <div className="loan-section">
        <Container>
          <Row>
            <Col sm="12" className="text-center">
              <h2>Our Offers</h2>
              <p className="m-0 pb-5">
                {gethomepageData && gethomepageData.our_offers_dec}
              </p>
            </Col>
          </Row>
          <Row className="tabflex">
            <Col lg="6" md="6" className="align-self-center">
              <h2>Interior design</h2>
              <p>{gethomepageData && gethomepageData.interior_design_text}</p>
              <div className="header-button">
                <a href="/">learn more</a>
              </div>
            </Col>
            <Col lg="6" md="6" className="align-self-center">
              <div className="loan-img-sec">
                {gethomepageData && (
                  <video
                    style={{ width: "100%" }}
                    src={`${config.BASE_URL}uploads/${gethomepageData.interior_design_image}`}
                    type="video/mp4"
                    controls
                    autoPlay
                    muted
                  />
                )}
                ;
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col lg="6" md="6" className="align-self-center">
              <div className="loan-img-sec">
                {gethomepageData && (
                  <video
                    style={{ width: "100%" }}
                    src={`${config.BASE_URL}uploads/${gethomepageData.home_loan_image}`}
                    type="video/mp4"
                    controls
                    autoPlay
                    muted
                  />
                )}
                ;
              </div>
            </Col>
            <Col lg="6" md="6" className="align-self-center">
              <h2>Home loan</h2>
              <p>{gethomepageData && gethomepageData.home_loan_text}</p>
              <div className="header-button">
                <a href="/">learn more</a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="buy-us partner-sec">
        <Container>
          <Row>
            <Col sm="12">
              <h2>Our Partner</h2>
              <p>{gethomepageData && gethomepageData.our_partner_text}</p>
            </Col>
            <Ourpartner />
          </Row>
        </Container>
      </div>
      <div className="brokerage">
        <Container>
          <Row>
            <Col col="12" md="5" lg="5" className="align-self-center">
              <h2 className="text-shadows">0%</h2>
            </Col>
            <Col col="12" md="7" lg="7" className="align-self-center">
              <div className="zero-content">
                <h1>
                  Zero
                  <br /> Brokerage
                </h1>
                <h4>
                  Experience a hassle-free real estate transaction with our ZERO
                  Brokerage services. Our team of licensed professionals is
                  dedicated to providing you with exceptional service and
                  support, without any hidden fees or commissions.
                </h4>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Home;
